<template>
  <div
    class="map-wrapper"
    :class="userDevice"
  >
    <div class="map-container">
      <template v-if="userDevice !== 'mobile'">
        <map-header-template></map-header-template>
        <div class="second-row">
          <div class="second">
            <div class="div-icon">
              <div class="div-circle circle-wait">
                <p>진행</p>
              </div>
              <div class="div-circle circle-proceeding">
                <div>
                  <p>미션</p>
                  <p>시도</p>
                </div>
              </div>
              <div class="div-circle circle-succeeded">
                <p>성공</p>
              </div>
            </div>

            <map-stage-template
              v-if="isLoading"
              v-for="(category, ci) in title"
              :key="category"
              :title="category"
              :desc="desc[ci]"
              :missions="missions[ci]"
            ></map-stage-template>

            <div class="second-hr"></div>
            <div
              class="btn learn-result-btn"
              :class="isAnalysisActive"
              v-on:click="openAnalysis()"
            >
              <div>학습 결과 보기</div>
            </div>
            <div class="warning"><b>최소 모든 미션을 1번이상 시도해야만 학습 결과 보기가 가능합니다.</b></div>
          </div>
        </div>
      </template>
      <template v-else>
        <img
          @click="showModal('map-alert-template', '본 서비스는 PC / 태블릿에서<br/>사용 가능합니다.')"
          src="../assets/images/map/mobile_bg.jpg"
        >
      </template>
    </div>

    <component
      v-if="isShowModal"
      :is="modal"
      :data="modalData"
      @close="isLoginPopup ? toLogin() : isShowModal = false"
      :userDevice="userDevice"
    ></component>
    <component
      v-if="isShowAnalysisModal"
      :is="modal"
      :data="modalDataAnalysis"
      @close="closeAnalysis()"
      :userDevice="userDevice"
    ></component>
  </div>
</template>


<script>

import { axios, was } from '@/lib/axios';
import mobileDetect from 'mobile-detect'

import mapStageTemplate from './map/MapPartialStage'
import mapHeaderTemplate from './map/MapPartialHeader'
import mapAlertTemplate from './map/MapAlert'

import { title, desc } from '../data.json'

const BROWSER_TYPE = navigator.userAgent.toLowerCase();
let gaScript;
if (
  BROWSER_TYPE.indexOf('msie 10.0') > -1 // IE 10
  || BROWSER_TYPE.indexOf('msie 9.0') > -1 // IE 9
  || BROWSER_TYPE.indexOf('msie 8.0') > -1 // IE 8
  || BROWSER_TYPE.indexOf('msie 7.0') > -1 // IE 7
) gaScript = require('../../static/assets/js/utility/googleanalytics-ie10')
else gaScript = require('../../static/assets/js/utility/googleanalytics')

let cmpList;
if (window.NODE_ENV === 'production' && window.NODE_REL === 'release') {
  cmpList = {
    mapStageTemplate,
    mapHeaderTemplate,
    mapAlertTemplate,
    gaScript
  };
} else {
  cmpList = {
    mapStageTemplate,
    mapHeaderTemplate,
    mapAlertTemplate,
  };
}
export default {
  name: "CodmosMap",
  components: cmpList,
  data () {
    return {
      title,
      desc,
      missions: (() => {
        const arr1 = []
        for (let i = 1; i <= 4; i++) {
          const arr2 = [];
          for (let z = 1; z <= 10; z++) {
            arr2.push([`ESOF01_1_${i}_${z}`, 0]);
          }
          arr1.push(arr2);
        }
        return arr1;
      })(),
      isShowModal: false,
      modal: '',
      modalData: null,
      userCount: 314149,
      isLoading: false,
      allClear: false,
      allClearMission: false,
      allTry: false,
      tryCnt: 0,
      clearCnt: 0,
      userDevice: 'pc',
      isAnalysisActive: 'active',
      isLoginPopup: false,
      isShowAnalysisModal: false,
      modalDataAnalysis: null
    }
  },
  created () {
    const MD = new mobileDetect(window.navigator.userAgent);

    if (MD.tablet() !== null) this.userDevice = 'tablet';
    else if (MD.mobile() !== null) this.userDevice = 'mobile';

    this.getUser()
  },
  mounted: function () {
    // alert(`Cookie : ${document.cookie}`);
    this.isLoading = false;
    this.getUser(() => {
      was.get(`${this.API_SERVER_URL}/manage/codmos/record/convert/ESOF01/1/0/0?${this.randomId()}`)
        .then(res => {
          if (res.data.code !== '1000' || !Array.isArray(res.data.docs)) return;
          res.data.docs.forEach(e => {
            const IS_CLEARED = e.isCleared ? 2 : 1;
            this.clearCnt++;
            if (IS_CLEARED > this.missions[e.stageCat - 1][e.missionCat - 1][1]) {
              // 미션을 한번이라도 시도한 상태
              this.missions[e.stageCat - 1][e.missionCat - 1][1] = IS_CLEARED;
              this.tryCnt++;    // 미션 시도 회수(미션별 Unique)
            }

            // 미션 최소 1번 이상 실행시 "학습결과보기" 버튼 활성화
            this.isAnalysisActive = (this.tryCnt > 0 ? 'active' : 'inactive');

          })
        })
        .finally(() => {
          this.allClear = !this.missions.some(e => e.some(e2 => !e2[1]));
          this.isLoading = true;
          // 30종 미션을 한번이라도 시도하였을 경우
          if (this.tryCnt >= 30) {
            this.allTry = true;
          }
          // 30종 모든 미션 Clear 여부 체크
          this.allClearMission = this.missions.every(e => e.every(e2 => e2[1] === 2));
        })
    })
  },
  methods: {
    toLogin () {
      location.href = '/sso/loginView.do';
    },
    showModal (tpl, text) {
      if (this.isShowModal === true) return;
      this.modalData = text || '로그인을 해주세요';
      this.modal = tpl || 'map-alert-template';
      this.isShowModal = true
    },
    getUser (cb) {
      was.post(`${this.API_SERVER_URL}/manage/codmos/user/convert`, {})
        .then(res => {
          switch (res.data.code) {
            case '1000': {
              document.cookie = 'userType=convert; path=/; expires=Thur, 31 Dec 2099 23:59:59 UTC;';
              if (typeof cb === 'function') cb();
              break
            }
            case '3000':
            case '2000':
            default: {
              console.log(`Return Code : ${res.data.code} | ReturnData : ${JSON.stringify(res.data)}`);
              this.isLoginPopup = true;
              this.showModal();
              break
            }
          }
        })
        .catch(e => {
          console.log(`Exception : ${e}`);
          this.isLoginPopup = true;
          this.showModal();
        })
    },
    openAnalysis () {

      // iframe 삽입방식으로 인하여 로직변경(팝업창 호출없이 바로 실행)
      if (this.tryCnt > 0) {
        location.href = '/codmos/analysis';
      }
    },
    closeAnalysis () {
      this.isShowAnalysisModal = false; // 팝업창 종료

      // 30종 미션 전체 시도 완료
      if (this.allTry) {
        location.href = '/codmos/analysis';
      }
      // 30종 미실행 미션이 있을 경우
      else {

      }
    }
  }
}
</script>

<style>
@import "../assets/styles/map/map_default.css";
</style>
<style lang="scss">
@import "../assets/styles/map/map_tablet";
@import "../assets/styles/map/map_mobile";

.warning {
  margin-top: 15px;
  margin-bottom: 70px;
}
</style>



// WEBPACK FOOTER //
// src/components/CodmosMap.vue